/* eslint-disable react/no-danger */
import React from 'react'
import PropTypes from 'prop-types'

import Text from '@hixme-ui/text'
import Title from '@hixme-ui/title'
import Container from '@hixme-ui/container'

const Message = ({ HixmeEmailAlias, Subject, Body }) => {
  const createHtmlMarkup = () => ({ __html: Body })

  return (
    <Container flex noPadding direction="column">
      <Container flex noPadding justifyContent="center" margin="0 0 20px 0">
        <Title small>{Subject}</Title>
      </Container>
      <Text>To: {HixmeEmailAlias}</Text>
      <Text>Subject: {Subject}</Text>
      <Container flex noPadding margin="20px 0 0 0">
        <Text>
          <div dangerouslySetInnerHTML={createHtmlMarkup()} />
        </Text>
      </Container>
    </Container>
  )
}

Message.displayName = 'Message'

Message.propTypes = {
  HixmeEmailAlias: PropTypes.string,
  Subject: PropTypes.string,
  Body: PropTypes.string,
}

Message.defaultProps = {
  HixmeEmailAlias: '',
  Subject: '',
  Body: '',
}

export default Message
